import _merge from 'lodash/merge';
import { defaultTheme } from 'bonfire-kindling';

const blue = '#2A6DB6';
const sky = '#E4EDF6';
const navy = '#2A4372';

const darkGreen = '#4CB564';
const green = '#46D1A0';
const lightGreen = '#A2E8CF';

const purple = '#673490';
const lightPurple = '#D5C5DF';

const orange = '#F8981D';
const lightOrange = '#FBCB8E';

const grey = '#949494';
const darkGrey = '#4E4E4E';
const lightGrey = '#BFBFBF';
const lighterGrey = '#BBBBBB';
const lightestGrey = '#D6D6D6';

const red = '#E6002C';

const theme = {
  palette: {
    hover: {
      dark: '#BCCCDF',
      main: '#E2E9F3',
    },
    secondary: {
      main: orange,
    },
    support: {
      main: '#4CC99B',
      dark: '#368f6e',
    },
    blue: {
      dark: navy,
      main: blue,
      light: sky,
    },
    green: {
      dark: darkGreen,
      main: green,
      light: lightGreen,
    },
    purple: {
      main: purple,
      light: lightPurple,
    },
    orange: {
      main: orange,
      light: lightOrange,
    },
    grey: {
      main: grey,
      dark: darkGrey,
      light: lightGrey,
      lighter: lighterGrey,
      lightest: lightestGrey,
    },
    red: {
      main: red,
    },
    error: {
      main: 'rgb(137, 5, 21)',
    },
    background: {
      main: '#F1F5FB',
    },
  },
};

export default _merge(defaultTheme, { palette: theme.palette });

export const testTheme = _merge(defaultTheme, {
  palette: theme.palette,
  transitions: { create: () => 'none' },
});
